/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { KeyTaskLabelFormulaRequest } from '../models/KeyTaskLabelFormulaRequest';
import type { KeyTaskLabelFormulaResponse } from '../models/KeyTaskLabelFormulaResponse';
import type { TaskSummaryKeyTasksResponse } from '../models/TaskSummaryKeyTasksResponse';
import type { TaskSummaryMonthlyByBusinessResponse } from '../models/TaskSummaryMonthlyByBusinessResponse';
import type { TaskSummaryMonthlyByDepartmentResponse } from '../models/TaskSummaryMonthlyByDepartmentResponse';
import type { TaskSummaryMonthlyResponse } from '../models/TaskSummaryMonthlyResponse';
import type { TaskSummaryStrategyResponse } from '../models/TaskSummaryStrategyResponse';
import type { TaskSummaryTotalByBusinessResponse } from '../models/TaskSummaryTotalByBusinessResponse';
import type { TaskSummaryTotalByDepartmentResponse } from '../models/TaskSummaryTotalByDepartmentResponse';
import type { TaskSummaryTotalResponse } from '../models/TaskSummaryTotalResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskSummaryService {
    /**
     * Get Task Summary Total
     * 전체 Task 요약 정보 조회
     *
     * 워크스페이스별 Task, TaskItem, TaskBudget, TaskPerformance의 전체 요약 통계를 제공합니다.
     * @returns TaskSummaryTotalResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskSummaryTotal({
        workspaceId,
        departmentId,
        businessId,
        assigneeId,
        subAssigneeId,
        managerId,
        reviewerId,
        stakeholderId,
        startDate,
        endDate,
    }: {
        workspaceId: string,
        departmentId?: string,
        businessId?: string,
        assigneeId?: string,
        subAssigneeId?: string,
        managerId?: string,
        reviewerId?: string,
        stakeholderId?: string,
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<TaskSummaryTotalResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/summary/total',
            query: {
                'workspace_id': workspaceId,
                'department_id': departmentId,
                'business_id': businessId,
                'assignee_id': assigneeId,
                'sub_assignee_id': subAssigneeId,
                'manager_id': managerId,
                'reviewer_id': reviewerId,
                'stakeholder_id': stakeholderId,
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Summary Total By Business
     * 사업별 Task 요약 정보 조회
     *
     * 워크스페이스 내 각 사업별로 그룹화된 Task 요약 통계를 제공합니다.
     * @returns TaskSummaryTotalByBusinessResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskSummaryTotalByBusiness({
        workspaceId,
        departmentId,
        businessId,
        assigneeId,
        subAssigneeId,
        managerId,
        reviewerId,
        stakeholderId,
        startDate,
        endDate,
    }: {
        workspaceId: string,
        departmentId?: string,
        businessId?: string,
        assigneeId?: string,
        subAssigneeId?: string,
        managerId?: string,
        reviewerId?: string,
        stakeholderId?: string,
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<TaskSummaryTotalByBusinessResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/summary/total/business',
            query: {
                'workspace_id': workspaceId,
                'department_id': departmentId,
                'business_id': businessId,
                'assignee_id': assigneeId,
                'sub_assignee_id': subAssigneeId,
                'manager_id': managerId,
                'reviewer_id': reviewerId,
                'stakeholder_id': stakeholderId,
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Summary Total By Department
     * 부서별 Task 요약 정보 조회
     *
     * 워크스페이스 내 각 부서별로 그룹화된 Task 요약 통계를 제공합니다.
     * @returns TaskSummaryTotalByDepartmentResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskSummaryTotalByDepartment({
        workspaceId,
        departmentId,
        businessId,
        assigneeId,
        subAssigneeId,
        managerId,
        reviewerId,
        stakeholderId,
        startDate,
        endDate,
    }: {
        workspaceId: string,
        departmentId?: string,
        businessId?: string,
        assigneeId?: string,
        subAssigneeId?: string,
        managerId?: string,
        reviewerId?: string,
        stakeholderId?: string,
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<TaskSummaryTotalByDepartmentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/summary/total/department',
            query: {
                'workspace_id': workspaceId,
                'department_id': departmentId,
                'business_id': businessId,
                'assignee_id': assigneeId,
                'sub_assignee_id': subAssigneeId,
                'manager_id': managerId,
                'reviewer_id': reviewerId,
                'stakeholder_id': stakeholderId,
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Summary Monthly
     * 월별 Task 요약 정보 조회
     *
     * 워크스페이스별 Task의 월별 시계열 요약 통계를 제공합니다.
     * 전체 총계와 월별 분해 데이터를 모두 포함합니다.
     * @returns TaskSummaryMonthlyResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskSummaryMonthly({
        workspaceId,
        departmentId,
        businessId,
        assigneeId,
        subAssigneeId,
        managerId,
        reviewerId,
        stakeholderId,
        startDate,
        endDate,
    }: {
        workspaceId: string,
        departmentId?: string,
        businessId?: string,
        assigneeId?: string,
        subAssigneeId?: string,
        managerId?: string,
        reviewerId?: string,
        stakeholderId?: string,
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<TaskSummaryMonthlyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/summary/monthly',
            query: {
                'workspace_id': workspaceId,
                'department_id': departmentId,
                'business_id': businessId,
                'assignee_id': assigneeId,
                'sub_assignee_id': subAssigneeId,
                'manager_id': managerId,
                'reviewer_id': reviewerId,
                'stakeholder_id': stakeholderId,
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Summary Monthly By Business
     * 사업별 월별 Task 요약 정보 조회
     *
     * 워크스페이스 내 각 사업별로 그룹화된 월별 Task 요약 통계를 제공합니다.
     * @returns TaskSummaryMonthlyByBusinessResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskSummaryMonthlyByBusiness({
        workspaceId,
        departmentId,
        businessId,
        assigneeId,
        subAssigneeId,
        managerId,
        reviewerId,
        stakeholderId,
        startDate,
        endDate,
    }: {
        workspaceId: string,
        departmentId?: string,
        businessId?: string,
        assigneeId?: string,
        subAssigneeId?: string,
        managerId?: string,
        reviewerId?: string,
        stakeholderId?: string,
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<TaskSummaryMonthlyByBusinessResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/summary/monthly/business',
            query: {
                'workspace_id': workspaceId,
                'department_id': departmentId,
                'business_id': businessId,
                'assignee_id': assigneeId,
                'sub_assignee_id': subAssigneeId,
                'manager_id': managerId,
                'reviewer_id': reviewerId,
                'stakeholder_id': stakeholderId,
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Summary Monthly By Department
     * 부서별 월별 Task 요약 정보 조회
     *
     * 워크스페이스 내 각 부서별로 그룹화된 월별 Task 요약 통계를 제공합니다.
     * @returns TaskSummaryMonthlyByDepartmentResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskSummaryMonthlyByDepartment({
        workspaceId,
        departmentId,
        businessId,
        assigneeId,
        subAssigneeId,
        managerId,
        reviewerId,
        stakeholderId,
        startDate,
        endDate,
    }: {
        workspaceId: string,
        departmentId?: string,
        businessId?: string,
        assigneeId?: string,
        subAssigneeId?: string,
        managerId?: string,
        reviewerId?: string,
        stakeholderId?: string,
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<TaskSummaryMonthlyByDepartmentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/summary/monthly/department',
            query: {
                'workspace_id': workspaceId,
                'department_id': departmentId,
                'business_id': businessId,
                'assignee_id': assigneeId,
                'sub_assignee_id': subAssigneeId,
                'manager_id': managerId,
                'reviewer_id': reviewerId,
                'stakeholder_id': stakeholderId,
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Summary Strategy
     * 전략과제 기준 대시보드 요약 조회
     *
     * 사업 › 전략과제 › 실행과제 단위와 부서 단위의 업무 진행률·예산 집행률·성과 달성률,
     * 월별 누적 현황을 한 번에 제공합니다. 해당 없는 지표는 null 입니다.
     * @returns TaskSummaryStrategyResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskSummaryStrategy({
        workspaceId,
        startDate,
        endDate,
    }: {
        workspaceId: string,
        startDate?: string,
        endDate?: string,
    }): CancelablePromise<TaskSummaryStrategyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/summary/strategy',
            query: {
                'workspace_id': workspaceId,
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Summary Key Tasks
     * 핵심 과제 현황 조회
     *
     * 사업별로 라벨(성과지표)이 붙은 세부실행과제와 과제 진행률·예산 집행률·성과 달성률을 제공합니다.
     * 기간 필터 없이 전체 데이터로 계산하며, 해당 없는 지표는 null 입니다.
     * @returns TaskSummaryKeyTasksResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskSummaryKeyTasks({
        workspaceId,
    }: {
        workspaceId: string,
    }): CancelablePromise<TaskSummaryKeyTasksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/summary/key-tasks',
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Key Task Label Formula
     *     핵심 과제 현황 지표 달성 계산기 수식 저장
     *
     * $1, $2 … 는 그 라벨 묶음에 보이는 세부실행과제 순서입니다 (목표수치 수식은 성과 목표, 달성수치 수식은 성과 달성 수치).
     * 둘 다 비우면 저장값을 지워 합계 계산으로 돌아갑니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns KeyTaskLabelFormulaResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateKeyTaskLabelFormula({
        requestBody,
    }: {
        requestBody: KeyTaskLabelFormulaRequest,
    }): CancelablePromise<KeyTaskLabelFormulaResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/task/summary/key-tasks/label-formula',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
}
